var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 5.99935C4.5 5.74046 4.5 5.61102 4.54222 5.50879C4.59873 5.37294 4.70682 5.26505 4.84278 5.20879C4.945 5.16602 5.07444 5.16602 5.33333 5.16602H7C7.25889 5.16602 7.38833 5.16602 7.49056 5.20824C7.62641 5.26474 7.7343 5.37283 7.79056 5.50879C7.83333 5.61102 7.83333 5.74046 7.83333 5.99935C7.83333 6.25824 7.83333 6.38768 7.79111 6.4899C7.73461 6.62576 7.62651 6.73365 7.49056 6.7899C7.38833 6.83268 7.25889 6.83268 7 6.83268H5.33333C5.07444 6.83268 4.945 6.83268 4.84278 6.79046C4.70692 6.73395 4.59903 6.62586 4.54278 6.4899C4.5 6.38768 4.5 6.25824 4.5 5.99935Z",
    stroke: "#313946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8898 3.22266V6.55599C10.8898 8.65099 10.8898 9.69877 10.2386 10.3493C9.58753 10.9999 8.54031 11.0004 6.44531 11.0004H5.88976C3.79476 11.0004 2.74698 11.0004 2.09642 10.3493C1.44587 9.69821 1.44531 8.65099 1.44531 6.55599V3.22266",
    stroke: "#313946",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.611328 2.11111C0.611328 1.58722 0.611328 1.32556 0.774106 1.16278C0.936884 1 1.19855 1 1.72244 1H10.6113C11.1352 1 11.3969 1 11.5597 1.16278C11.7224 1.32556 11.7224 1.58722 11.7224 2.11111C11.7224 2.635 11.7224 2.89667 11.5597 3.05944C11.3969 3.22222 11.1352 3.22222 10.6113 3.22222H1.72244C1.19855 3.22222 0.936884 3.22222 0.774106 3.05944C0.611328 2.89667 0.611328 2.635 0.611328 2.11111Z",
    stroke: "#313946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ac84f66546046b8faa29299f5a74a736.svg";
export { ForwardRef as ReactComponent };